const region = "us-east-1";

const qa = {
	appSettingsData: {
		BuyerCognitoGroup: "wl-qa-procurement-portal-buyers",
		SupplierCognitoGroup: "wl-qa-procurement-portal-suppliers",
		federatedIDPProvider: "wl-qa-procurement-portal-idp"
	},
	amplify_config: {
		Auth: {
			Cognito: {
				userPoolId: "us-east-1_I5eCFTYeO",
				userPoolClientId: "186iqd00ik4p1s10prnehlnmda",
				loginWith: {
					oauth: {
						domain: "wl-qa-procurement-portal.auth.us-east-1.amazoncognito.com",
						scopes: [],
						redirectSignIn: [
							"https://wl-qa-procurement-portal.com/login",
							"http://localhost:3000/login"
						],
						redirectSignOut: [
							"https://wl-qa-procurement-portal.com/login",
							"http://localhost:3000/login"
						],
						responseType: "code"
					}
				}
			}
		},
		API: {
			REST: {
				print: {
					endpoint: "https://api.wl-qa-procurement-portal.com/print",
					region: region
				}
			}
		}
	}
};

export default qa;
